// Copyright (c) 2017 Deere & Company

import Criteria, {getDefaultState as getDefaultCriteriaState} from '../state/criteria';
import actions from '../../actions-list';
import {updateList} from '../../../shared/services/list-selections';

const selectTerritory = (state, action) => {

    const selectedTerritories = updateList(
        action.territory,
        action.isSelected,
        'territory',
        state.selectedTerritories
    );

    return Criteria.update(state, {
        selectedTerritories: {
            $set: selectedTerritories
        }
    });

};

const selectAllTerritories = (state, action) => {

    const toggleSelectedTerritories = state.selectedTerritories.length > 0 ? [] : action.territories;

    return Criteria.update(state, {
        selectedTerritories: {
            $set: toggleSelectedTerritories
        }
    });

};

const selectOriginalSubmissionDate = (state, action) =>
    Criteria.update(state, {
        originalSubmissionDate: {
            from: {
                $set: action.originalSubmissionDate.from
            },
            to: {
                $set: action.originalSubmissionDate.to
            }
        }
    });

const resetCriteria = () => getDefaultCriteriaState();

export default (state = getDefaultCriteriaState(), action) => {

    const actionTypes = {
        [actions.RESET_SPECIAL_ALLOWANCE_CLAIM_STATUS_REPORT]: resetCriteria,
        [actions.SELECT_ALL_SPECIAL_ALLOWANCE_CLAIM_STATUS_TERRITORIES]: selectAllTerritories,
        [actions.SELECT_ORIGINAL_SUBMISSION_DATE]: selectOriginalSubmissionDate,
        [actions.SELECT_SPECIAL_ALLOWANCE_CLAIM_STATUS_TERRITORY]: selectTerritory
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/reducers/criteria.js